<template>
  <v-row class="ma-2">
    <v-col cols="12">
      <v-row no-gutters>
        <v-col v-if="images && images.length > 0" cols="12">
          <v-row no-gutters>
            <v-col v-for="(im, n) in images" :key="n" class="d-flex child-flex" cols="3">
              <v-hover v-slot="{ hover }">
                <v-img
                  :src="im"
                  :lazy-src="im"
                  aspect-ratio="1"
                  max-height="150"
                  max-width="200"
                  class="gallery-img ma-2 grey lighten-2"
                >
                  <v-expand-transition>
                    <div
                      v-if="hover"
                      class="d-flex overlay justify-center transition-fast-in-fast-out primary white--text"
                      style="height: 100%"
                      @click="openDialog(n)"
                    >
                      <v-icon class="image" color="background">mdi-magnify-plus</v-icon>
                    </div>
                  </v-expand-transition>
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-hover>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-else cols="12">No image available! </v-col>
      </v-row>
    </v-col>

    <!-- Overlay for large image view -->
    <v-overlay class="layering" :value="dialog">
      <div
        ref="overlayWrapper"
        class="overlay-wrapper"
        tabindex="0"
        @keydown.left="prevImage"
        @keydown.right="nextImage"
      >
        <input ref="focusableInput" type="text" style="position: absolute; opacity: 0" />

        <v-card
          :light="!this.$vuetify.theme.dark"
          class="backgroundWhite"
          style="width: 80vw; max-height: 80vh; overflow: auto"
        >
          <div class="close-btn">
            <v-btn right @click="closeDialog" outlined color="primaryGrey" class="py-4" x-small>
              <v-icon small color="primaryGrey">mdi-close</v-icon>
            </v-btn>
          </div>

          <v-btn v-if="images.length > 1" large class="ml-4 left-arrow" @click="prevImage" icon>
            <v-icon large>mdi-chevron-left</v-icon>
          </v-btn>

          <div class="pa-4" style="overflow: auto; height: 100%">
            <v-row class="mx-3 py-4 justify-center" no-gutters>
              <v-img
                :src="images[selected_image]"
                :lazy-src="images[selected_image]"
                contain
                aspect-ratio="1"
                max-height="500"
                max-width="700"
                class="gallery-img ma-2 backgroundWhite"
              />
            </v-row>
          </div>

          <v-btn v-if="images.length > 1" large class="mr-4 right-arrow" @click="nextImage" icon>
            <v-icon large>mdi-chevron-right</v-icon>
          </v-btn>
        </v-card>
      </div>
    </v-overlay>
  </v-row>
</template>

<script>
import { axios_get } from "../services/vt_service";
import { scv } from "../services/powerdata";

export default {
  name: "ImageGallery",
  props: {
    device_id: String,
  },
  data: function () {
    return {
      dialog: false,
      images: [],
      selected_image: null,
    };
  },
  mounted() {
    this.get_installation_images();
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.selected_image = null;
    },
    openDialog(index) {
      this.dialog = true;
      this.selected_image = index;
      this.$nextTick(() => {
        // Check if ref exists before calling focus
        if (this.$refs.overlayWrapper) {
          this.$refs.overlayWrapper.focus();
        } else {
          console.error("Ref not found");
        }
      });
    },
    async get_installation_images() {
      this.dialog = false;
      this.overlay_type = "";
      this.network_error = false;
      let response = await axios_get(scv.get_installation_images, { id: this.device_id });
      this.images = response;
    },
    prevImage() {
      if (this.selected_image > 0) {
        this.selected_image--;
      } else {
        this.selected_image = this.images.length - 1;
      }
    },
    nextImage() {
      if (this.selected_image < this.images.length - 1) {
        this.selected_image++;
      } else {
        this.selected_image = 0;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .gallery-img {
  border-radius: 3px;
}
::v-deep .overlay {
  opacity: 0.9;
  cursor: pointer;
}
::v-deep .zoom {
  position: absolute;
  top: 45%;
  cursor: pointer;
}
.close-btn {
  position: absolute;
  right: 0;
  z-index: 9;
  padding: 1em;
}
.left-arrow,
.right-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
}
.left-arrow {
  left: 10px;
}
.right-arrow {
  right: 10px;
}
.overlay-wrapper {
  outline: none;
}
</style>
